import baseService from '../shared/baseService';

const circulationService = () => baseService('circulations');

export default {
    circulationService
};

